type RuntimeConfig = {
    cryptoDisabled?: boolean
}

export const isCryptoPaymentDisabled = (): boolean => {
    const runtime = (window as Window & { __RUNTIME_CONFIG__?: RuntimeConfig }).__RUNTIME_CONFIG__
    if (typeof runtime?.cryptoDisabled === 'boolean') {
        return runtime.cryptoDisabled
    }
    return process.env.REACT_APP_CRYPTO_DISABLED === '1'
}
